import RoutesMap from "route_control/RouteControl"
import { StockList, AddStock, StockAvailability } from "pages/inventory"

const InventoryRoute = () => {
    return [
        {
            path: RoutesMap.STOCK_LIST.path,
            element: <StockList />
        },
        {
            path: RoutesMap.ADD_STOCK.path,
            element: <AddStock />
        },
        {
            path: RoutesMap.STOCK_AVAILABILITY.path,
            element: <StockAvailability />
        },
    ]
}

export default InventoryRoute;